import API from './api';

export const blogService = {
  // Public: list published blogs
  getBlogs: (params) => API.get('/blogs', { params }),

  // Public: single blog detail
  getBlogById: (id) => API.get(`/blogs/${id}`),

  // Admin: single blog detail (including unpublished)
  getAdminBlogById: (id) => API.get(`/blogs/admin/${id}`),

  // Admin: list all blogs (including unpublished)
  getAllBlogsAdmin: (params) => API.get('/blogs/admin/all', { params }),

  // Admin: create blog (multipart/form-data with image)
  createBlog: (formData) =>
    API.post('/blogs', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),

  // Admin: update blog (multipart/form-data with optional image)
  updateBlog: (id, formData) =>
    API.put(`/blogs/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),

  // Admin: delete blog
  deleteBlog: (id) => API.delete(`/blogs/${id}`),
};
